import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o$1 } from '../../../../node_modules/lit-html/directives/class-map.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL, wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import css_248z from './sign-up.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';

class SignUp extends s {
    constructor() {
        super(...arguments);
        this.colorScheme = 'purple';
    }
    static generateHeadlineId() {
        SignUp.instanceCounter += 1;
        return `signup-title-${SignUp.instanceCounter}`;
    }
    renderGenericButton(type, ctaButton) {
        if (!(ctaButton === null || ctaButton === void 0 ? void 0 : ctaButton.url)) {
            return null;
        }
        const ctaLabel = ctaButton.title || '';
        const ctaHref = ctaButton.url;
        const ctaTarget = ctaButton.target || '_self';
        const ctaStyleType = 'dark';
        const ariaList = ctaButton.ariaLabel
            ? { label: ctaButton.ariaLabel }
            : undefined;
        return $ `<generic-button-updated type="${type}" .label="${ctaLabel}" .href="${ctaHref}" .target="${ctaTarget}" .styleType="${ctaStyleType}" .ariaList="${ariaList}" ?isNoFollow="${ctaButton.isNoFollow || false}" ?rtl="${this.rtl || isRTL()}" class="cta-link cta-link--${type}"></generic-button-updated>`;
    }
    renderCtaGroup() {
        var _a, _b;
        const hasCtas = ((_a = this.primaryCta) === null || _a === void 0 ? void 0 : _a.url) || ((_b = this.secundaryCta) === null || _b === void 0 ? void 0 : _b.url);
        if (!hasCtas) {
            return null;
        }
        return $ `<div class="cta-group">${this.renderGenericButton('primary', this.primaryCta)} ${this.renderGenericButton('secondary', this.secundaryCta)}</div>`;
    }
    renderHeadline(headlineId) {
        if (!this.headline) {
            return null;
        }
        return $ `<h2 id="${headlineId}" class="signup-component__headline">${o(this.headline)}</h2>`;
    }
    renderBodyText() {
        if (!this.body) {
            return null;
        }
        return $ `<div class="signup-component__description rte">${o(wrapRichTextTables(this.body))}</div>`;
    }
    renderTrademarkText() {
        if (!this.trademarkText) {
            return null;
        }
        return $ `<p class="signup-component__trademark">${o(this.trademarkText)}</p>`;
    }
    render() {
        const headlineId = SignUp.generateHeadlineId();
        const logo = $ `<img src="${this.logoSrc}" alt="${this.logoAlt}" class="signup-component__logo">`;
        const signUpClassMap = {
            bottom: this.isBottom || false,
            rtl: this.rtl || isRTL(),
            'color-scheme--purple': this.colorScheme === 'purple',
            'color-scheme--night': this.colorScheme === 'night',
        };
        if (this.isBottom) {
            return $ `<section class="sign-up ${o$1(signUpClassMap)}" aria-labelledby="${headlineId}"><div class="signup-component__left-container">${this.renderHeadline(headlineId)}</div><div class="signup-component__right-container"><div class="signup-component_logo-group">${logo}</div>${this.renderBodyText()} ${this.renderCtaGroup()} ${this.renderTrademarkText()}</div></section>`;
        }
        return $ `<section class="sign-up ${o$1(signUpClassMap)}" aria-labelledby="${headlineId}"><div class="signup-component__left-container"><div class="signup-component_logo-group">${logo}</div></div><div class="signup-component__right-container">${this.renderHeadline(headlineId)} ${this.renderCtaGroup()}</div></section>`;
    }
}
SignUp.styles = css_248z;
SignUp.instanceCounter = 0;
__decorate([
    e({ type: Boolean })
], SignUp.prototype, "isBottom", void 0);
__decorate([
    e({ type: String })
], SignUp.prototype, "headline", void 0);
__decorate([
    e({ type: String })
], SignUp.prototype, "body", void 0);
__decorate([
    e({ type: Boolean })
], SignUp.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], SignUp.prototype, "logoAlt", void 0);
__decorate([
    e({ type: String })
], SignUp.prototype, "logoSrc", void 0);
__decorate([
    e({ type: Object })
], SignUp.prototype, "primaryCta", void 0);
__decorate([
    e({ type: Object })
], SignUp.prototype, "secundaryCta", void 0);
__decorate([
    e({ type: String })
], SignUp.prototype, "colorScheme", void 0);
__decorate([
    e({ type: String })
], SignUp.prototype, "trademarkText", void 0);
customElements.define('sign-up', SignUp);

export { SignUp };
